// extracted by mini-css-extract-plugin
export default {"searchPanel":"searchPanel_searchPanel__b2Zgd"};